"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var widths = {
  wide: 380,
  slim: 220,
  mini: 220
};
var _default = exports["default"] = widths;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/offers/utils/truncateWidthsByCardStyle.js
// module id = 1124
// module chunks = 25